
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import BForm from 'Src/js/components/blain-form/BForm.vue';
import Icon from 'Src/js/components/Icon.vue';
import LinkButton from 'Src/js/components/LinkButton.vue';
import Spinner from 'JS/components/Spinner.vue';
import UiButton from 'JS/components/UiButton.vue';
import { getIntialFocusElement } from 'JS/utilities/dom';

@Component({
	name: 'StepWrapper',
	components: {
		LinkButton,
		Icon,
		UiButton,
		BForm,
		Spinner,
	}
})
class StepWrapper extends Vue {
	$refs!: {
		form: BForm;
	}

	@Prop({ type: String, required: true })
	title: string;

	@Prop({ type: Boolean })
	hasPreviousStep: boolean;

	@Prop({ type: Boolean })
	canContinue: boolean;

	@Prop({ type: Boolean })
	loading: boolean;

	@Prop({ type: Boolean, default: true })
	autofocus: boolean;

	get formHandle(): BForm {
		return this.$refs.form;
	}

	mounted() {
		if (this.autofocus) {
			this.$nextTick(() => {
				getIntialFocusElement(this.$el)?.focus();
			});
		}
	}
}

export default StepWrapper;
